import React from "react";
import { CheckCircle } from "lucide-react";

interface UserListProps {
  users: any[];
  loading: boolean;
  searchTerm: string;
  selectedIds: string[];
  onSelect: (userId: string) => void;
  multiple?: boolean;
}

export const UserList: React.FC<UserListProps> = ({
  users,
  loading,
  searchTerm,
  selectedIds,
  onSelect,
  multiple = true,
}) => {
  const filteredUsers = users.filter(
    (user) =>
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.phonenumber?.includes(searchTerm)
  );

  return (
    <div className="space-y-2 max-h-[500px] overflow-y-auto">
      {loading ? (
        <p className="py-4 text-center text-gray-500">Chargement...</p>
      ) : filteredUsers.length === 0 ? (
        <p className="py-4 text-center text-gray-500">Aucun utilisateur trouvé</p>
      ) : (
        filteredUsers.map((user) => {
          const isSelected = selectedIds.includes(user.id);
          return (
            <button
              key={user.id}
              onClick={() => onSelect(user.id)}
              className={`w-full text-left p-3 rounded-lg border transition-all ${
                isSelected ? "border-green-500 bg-green-50" : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
              }`}
            >
              <div className="flex gap-3 items-center">
                {multiple && (
                  <div
                    className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                      isSelected ? "bg-green-600 border-green-600" : "border-gray-300"
                    }`}
                  >
                    {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                  </div>
                )}
                <div className="flex justify-center items-center w-10 h-10 font-semibold text-green-600 bg-green-100 rounded-full">
                  {user.first_name?.charAt(0).toUpperCase() || "U"}
                </div>
                <div className="flex-1">
                  <p className="font-medium text-gray-900">
                    {`${user.first_name || ""} ${user.last_name || ""}`.trim() || "Sans nom"}
                  </p>
                  <p className="text-sm text-gray-600">{user.email}</p>
                  {user.phonenumber && <p className="text-xs text-gray-500">{user.phonenumber}</p>}
                </div>
              </div>
            </button>
          );
        })
      )}
    </div>
  );
};
